<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Select video track</div>
    <div class="modal-body">
      <!-- Every rendition the manifest declares, whether or not this browser can play it. An
           unplayable one is shown disabled rather than omitted: the preview exists to confirm what
           was encoded, and silently dropping a codec made the encode look incomplete. -->
      @for (rendition of renditions; track $index) {
        <div class="form-check" aria-label="Select Stream Type"
          >
          <!-- The id interpolated the rendition *object*, so every row rendered
               id="radio[object Object]": one id shared by all of them, and every label pointing at
               the first radio. Clicking any label picked the first rendition. Keyed on the index
               now -- an unplayable rendition has no id to key on.

               [checked] + (change) rather than [(ngModel)]: with ngModel the radio accessor owns
               `value`, and nothing came out preselected -- the dialog could not show which
               rendition was already playing. -->
          <input type="radio" class="form-check-input" id="radio_{{$index}}" name="videoRendition"
            [checked]="isPlayable(rendition) && rendition.id === currentlySelectedRendition"
            [disabled]="!isPlayable(rendition)"
            (change)="currentlySelectedRendition = rendition.id">
          <!-- One label for DASH and HLS: the player exposes the same fields for both, so the
               stream type is no longer part of how a rendition is described. -->
          <label class="form-check-label" for="radio_{{$index}}">
            {{ renditionLabel(rendition) }}
          </label>
          @if (!isPlayable(rendition)) {
            <p class="valid-feedback mb-0">Encoded, but this browser cannot play it — see below.</p>
          }
        </div>
      }
      @if (hasUnplayable()) {
        <p class="valid-feedback">
          Greyed-out renditions were encoded but cannot be played here. HEVC is the usual case: this
          content is encrypted, and Widevine — the only DRM Chrome has — offers no HEVC decoder, even
          where the browser decodes HEVC in the clear. Preview those in Safari, which uses FairPlay.
        </p>
      }
    </div>
    <div class="modal-footer">
      <span class="modal-footer-left cl-spacing-box cl-spacing-none">
        <button class="btn cl-color-secondary it-cancel" (click)="dialogRef.close()">
          <span>Cancel</span>
        </button>
      </span>
      <span class="modal-footer-right cl-spacing-box cl-spacing-none">
        <button class="btn cl-color-primary" (click)="dialogRef.close(currentlySelectedRendition)">
          <span>Select</span>
        </button>
      </span>
    </div>
  </div>
</div>


